<template>
    <div class="form-group">
        <label
            :class="{
                'text-danger': errors && errors.length,
                'text-dark': !errors || !errors.length,
                required: required
            }"
            :for="id"
        >
            <small v-if="labelSmall">{{ label }}</small>
            <template v-else>{{ label }}</template>
        </label>

        <input
            class="form-control rounded text-muted"
            :class="{ 'is-invalid': errors && errors.length, loading: loading }"
            :type="type"
            :readonly="readonly"
            :required="required"
            :disabled="disabled"
            :placeholder="placeholder"
            :id="id"
            :loading="loading"
            :value="value"
            v-on:input="$emit('input', $event.target.value)"
        />

        <small class="text-danger font-italic validation-error" style="font-size: 12px" v-if="errors && errors.length">
            {{ errors[0] }}
        </small>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            value: String,
            placeholder: String,
            loading: Boolean,
            required: Boolean,
            readonly: Boolean,
            disabled: Boolean,
            errors: Array,
            type: {
                default: 'text',
                type: String
            },
            label: {
                required: true,
                type: String
            },
            labelClass: {
                default: 'text-dark',
                type: String
            },
            labelSmall: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                id: `text-input-${this.uid}`
            };
        }
    });
</script>
